export const SET_SCATTER_CHART = "SET_SCATTER_CHART";